import React from 'react';
import LoadingDialog from 'components/LoadingDialog/LoadingDialog';
import IvicosStrings from 'kits/language/stringKit';
import SessionTakeoverScreen from './SessionTakeoverScreen';
import { ISessionClaim } from './useSessionClaim';

export interface ISessionGateProps {
    session: ISessionClaim;
    children?: React.ReactNode;
}

/** Renders Campus only while this tab holds the user's session; otherwise the takeover screen. */
const SessionGate: React.FC<ISessionGateProps> = ({ session, children }) => {
    switch (session.sessionState) {
        case 'active':
            return <>{children}</>;
        case 'claiming':
            return <LoadingDialog loadingStrings={[IvicosStrings.loadingStringCoreInitializing]} view="full" typewriter={false} />;
        case 'replaced':
            return <SessionTakeoverScreen variant="replaced" onPrimary={session.claimHere} />;
        case 'busy-open-elsewhere':
            return <SessionTakeoverScreen variant="open-elsewhere" onPrimary={session.continueHere} onSecondary={session.keepOtherSession} />;
        case 'busy-in-call':
            return <SessionTakeoverScreen variant="in-call" onPrimary={session.continueHere} onSecondary={session.keepOtherSession} />;
    }
};

export default SessionGate;
